import { useSelector } from 'react-redux';

import { appSelectors } from 'modules/app';

export const useApplicationMaintenance = () => {
  const isUnderMaintenance = useSelector(appSelectors.isUnderMaintenance);

  return isUnderMaintenance;
};
